import React from "react";
import { Button, Tooltip } from "antd";

interface ExportToButtonProps {
    onExport: (type: "pdf" | "xls") => void;
}

export function ExportButtons({ onExport }: ExportToButtonProps) {
    return (
        <>
            <Tooltip title="Exportar para excel">
                <Button
                    style={{
                        marginLeft: 8,
                        color: "#237804",
                    }}
                    icon="file-excel"
                    onClick={() => onExport("xls")}
                />
            </Tooltip>

            <Tooltip title="Exportar para pdf">
                <Button
                    style={{
                        color: "#fa541c",
                        marginLeft: 8,
                    }}
                    icon="file-pdf"
                    onClick={() => onExport("pdf")}
                />
            </Tooltip>
        </>
    );
}
